import {first} from '@shared/helpers/array'

import {getResultInfo} from '@web/actions/result'
import {ProductType, Status} from '@web/slices/pickup/slice'
import makeSlice from '@web/slices/pickup/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getResultInfo.fulfilled, (state, {payload}) => {
            const primaryProduct = first(payload.products)
            const primaryMerchant = first(Object.values(payload.merchantsByMerchantNo))

            if (!payload.pickUp || !primaryProduct || !primaryMerchant) {
                return
            }

            state.merchantName = primaryMerchant.name
            primaryProduct.branchName && (state.branchName = primaryProduct.branchName)
            state.code = payload.pickUp.qrCode
            state.productType = payload.pickUp.alcohol ? ProductType.ALCOHOL : ProductType.NORMAL
            state.status = Status.WAIT
            state.location = {
                address: payload.pickUp.baseAddress ?? '',
                ...(payload.pickUp.detailAddress && {
                    subAddress: payload.pickUp.detailAddress,
                }),
                ...(payload.pickUp.zipCode && {
                    zipCode: payload.pickUp.zipCode,
                }),
                imageUrl: primaryMerchant.merchantImageUrl ?? '',
                point: {
                    x: payload.pickUp.longitude ?? '',
                    y: payload.pickUp.latitude ?? '',
                },
                markerColor: payload.pickUp.markerColor ?? state.location.markerColor,
            }
        })
    },
})

export default slice.reducer
